<template>
  <div class="d-flex flex-column align-items-center" style="width: 3.5rem">
    <FlexCol
      class="rounded-circle border justify-content-center align-items-center text-center overflow-hidden"
      style="line-height: normal"
      :style="{
        color:
          settings.index > settings.checkedStamps - 1
            ? settings.beforeStampsTextColor
            : settings.textColor,
        'border-color': `${settings.beforeStampsBackgroundColor} !important`,
        background: isLastStamp
          ? settings.rewardBackgroundColor
          : settings.index > settings.checkedStamps - 1
          ? settings.beforeStampsBackgroundColor
          : 'transparent',
        fontSize: isLastStamp ? '14px' : '2rem',
        width: isLastStamp ? '4.6rem' : '4.5rem',
        height: isLastStamp ? '4.6rem' : '4.5rem',
        borderWidth: isLastStamp ? '0 !important' : '0.3rem !important',
      }"
    >
      <template v-if="isLastStamp">
        <img
          v-if="settings.rewardImageUrl"
          :src="settings.rewardImageUrl"
          alt="Reward"
          class="rounded-circle"
          style="object-fit: contain; width: 100%; height: 100%"
        />
        <span
          v-else-if="settings.rewardEmoji"
          class="d-flex align-items-center justify-content-center w-100 h-100"
          style="font-size: 2rem"
        >
          {{ settings.rewardEmoji }}
        </span>
        <span
          v-else
          style="word-break: break-word; max-width: 80%"
          :style="{ color: settings.rewardTextColor }"
          >{{ settings.reward }}</span
        >
      </template>
      <template v-else-if="settings.index <= settings.checkedStamps - 1">
        <img
          v-if="settings.stampImageUrl"
          :src="settings.stampImageUrl"
          alt="Stamp"
          style="object-fit: contain"
        />
        <span
          v-else-if="typeof settings.stampIcon === 'string'"
          class="d-flex align-items-center justify-content-center w-100 h-100"
          :style="{
            fontSize: '2rem',
            color: settings.textColor,
          }"
        >
          {{ settings.stampIcon }}
        </span>
        <component
          v-else
          :is="settings.stampIcon"
          width="3.5rem"
          :class="`text-${settings.textColor}`"
        />
      </template>
    </FlexCol>
    <span
      v-if="settings.index <= settings.checkedStamps - 1 && !isLastStamp"
      class="mt-1 text-center"
      style="font-size: 14px"
      :style="{
        color: settings.textColor,
      }"
    >
      {{ settings.dateText }}
    </span>
    <span
      v-else
      class="mt-1 text-center opacity-0"
      style="font-size: 14px"
      :style="{
        color: settings.textColor,
      }"
    >
      ""
    </span>
  </div>
</template>

<script setup>
import FlexCol from "@/layout/FlexCol.vue";
import { computed } from "vue";

const props = defineProps({
  settings: {
    type: Object,
    required: true,
  },
});

const isLastStamp = computed(
  () => props.settings.index === props.settings.totalStamps - 1
);
</script>
